import React from 'react';

const MultiCitySegments = ({
  segments,
  activeSegmentIndex,
  onSegmentClick,
  enrichedSegments,
  lockedSegmentIndices = [],
}) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
    const day = date.getDate();
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${weekday} ${day} ${month} ${year}`;
  };

  const handleSegmentClick = (index) => {
    if (lockedSegmentIndices.includes(index)) return;
    onSegmentClick(index);
  };

  if (!segments || segments.length === 0) return null;

  return (
    <div className="flex gap-4 mb-6 max-sm:flex-col max-sm:gap-2">
      {segments.map((segment, index) => {
        const isActive = index === activeSegmentIndex;
        const enriched = enrichedSegments[index];

        const fromDisplay = enriched ? `${enriched.fromAirport.iata}` : segment.from;
        const toDisplay = enriched ? `${enriched.toAirport.iata}` : segment.to;

        const isLocked = lockedSegmentIndices.includes(index);

        return (
          <div key={index} className="flex-1 min-w-0">
            <button
              type="button"
              onClick={() => handleSegmentClick(index)}
              disabled={isLocked}
              className={`w-full rounded-lg py-2.5 px-4 max-sm:px-3 text-center transition-all ${isActive
                  ? 'bg-jet-yellow'
                  : isLocked
                    ? 'bg-jet-gray-100 text-jet-gray-500 cursor-not-allowed opacity-80'
                    : 'bg-jet-gray-200 hover:bg-jet-gray-300 cursor-pointer'
                }`}
            >
              <div className="text-[0.9rem] max-sm:text-sm font-semibold text-jet-gray-900 mb-0.5 leading-tight">
                {fromDisplay} → {toDisplay}{isLocked ? ' 🔒' : ''}
              </div>
              <div className="text-[0.8rem] max-sm:text-xs text-jet-gray-700 font-semibold leading-tight">
                {formatDate(segment.date)}
              </div>
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default MultiCitySegments;
